import { useAnalytics } from '@/app/context/AnalyticsContext/useAnalytics';
import { useCustomer } from '@/app/context/CustomerContext/useCustomer';
import Loader from '@/components/common/loader/Loader';
import React from 'react';

export default function UpgradeSubscription() {
  const { isCreatingCheckoutSession, createCheckoutSession, country } =
    useCustomer();

  const { trackEvent, analyticsInstance } = useAnalytics();

  return (
    <div className="bordered flex flex-col gap-4 border-2 border-solid border-base-content p-8">
      {isCreatingCheckoutSession && (
        <div className="flex w-full flex-col items-center gap-6">
          <div>Launching Secure Checkout...</div>
          <Loader />
        </div>
      )}
      {!isCreatingCheckoutSession && (
        <>
          <button
            onClick={() => {
              trackEvent(analyticsInstance, 'account_click_upgrade');
              createCheckoutSession(true);
            }}
            className="btn btn-primary btn-sm"
          >
            Upgrade to Limbiks Pro
          </button>

          <div className="mt-2" style={{ maxWidth: 310 }}>
            <ul className="flex-1 space-y-2">
              {[
                `${country.currencySymbol}${country.monthlyRate}${country.currencySuffix}/month or ${country.currencySymbol}${country.yearlyRate}${country.currencySuffix}/year`,
                '100 uploads per month',
                'Select up to to 200 pages or slides',
                'AI Generated study guides',
                'Unlimited practice tests',
                'Unlimited multiple choice questions',
                'Get Hints and explanations',
                'Add Learning Objectives',
                'Add Custom Instructions',
                '500 Anki AI Occlusions per month'
              ].map((feature) => (
                <li key={feature} className="flex items-center space-x-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                    className="h-6 w-6 flex-shrink-0"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        </>
      )}
      <div className="mt-2" style={{ maxWidth: 300 }}>
        <div className="rounded bg-white">
          <img src="/stripe-badge-transparent.png" />
        </div>
      </div>
    </div>
  );
}
